import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { NavLink, Link } from "react-router-dom";
import logoUser from "../../images/logo.png"; /* '../../images/vixlogo.png'; */
import logoGuest from "../../images/logo.png"; /* '../../images/vixlogo.png'; */
import menuArrow from "../../images/menu-downarrow.webp";
import { CurrentUserContext } from "../../context/CurrentUserContext";
import "../Navigation/Navigation.css";
import Logout from "../../images/icons/Logout-icon.png";
import LangIcon from "../../images/icons/lang-icon.png";
import Home from "../../images/icons/home.svg";
import SignIn from "../../images/icons/signin.svg";
import SignOut from "../../images/icons/signout.svg";
import Profile from "../../images/icons/profile.svg";
import ProfileLite from "../../images/icons/profile-lite.svg";
import { useLanguage } from "../../context/LanguageContext";
import { useTranslation } from "../../utils/hooks/translateHook";

const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "fr", label: "Français" },
  { code: "tr", label: "Turkçe" },
  { code: "pt", label: "Português" },
  { code: "it", label: "Italiano"}
];

function Navigation({ onDesktopClick, onMobileClick, onMobileMenu, onSignOut, isLoggedIn }) {
  const { language, setLanguage } = useLanguage();
  const [showLangMenu, setShowLangMenu] = useState(false);
  const [showSignout, setShowSignout] = useState(false);
  const [ mobileOpen, setMobileOpen] = useState(false);
  const t = useTranslation();
  const { currentUser } = React.useContext(CurrentUserContext);
  const userRole = currentUser?.role || "guest";
  const isUser = isLoggedIn;

  const location = useLocation();
  const isAdmin =
    userRole === "admin" && location.pathname.startsWith("/admin");

  const langRef = useRef(null);

  const navClass = isUser ? "navigation-home" : "navigation";
  const menuItemClass = isUser ? "navigation__menu-item" : "navigation__menu-item-guest"; //nonmembera ayri css
  const buttonClass = isUser ? "navigation__menu-item navigation_menu-signout-button"  : "navigation__menu-item-guest navigation__menu-signIn-button";
  const logoImage = isUser ? logoUser : logoGuest;
  const navigate = useNavigate();

  const onLanguage = () => {
    setShowLangMenu((prev) => !prev);
    setShowSignout(false);
  };

  const handleSelect = (code) => {
    setLanguage(code);
    setShowLangMenu(false);
  };

  const toggleSignout = () => {
    setShowSignout((prev) => !prev);
    setShowLangMenu(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (langRef.current && !langRef.current.contains(event.target)) {
        setShowLangMenu(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      {/*div className="navcomponent" */}
      { 
        isAdmin ? (
          
          <nav className={`${navClass} lang-${language}`}>

            <div className="nav-mobile">
              <button className={`navigation__hamburger ${mobileOpen ? 'is-open' : ''}`} onClick={() => setMobileOpen(prev => !prev)}>
                {mobileOpen ? 'X': '☰' }
              </button>
{/*               <div className="logo-part">
                <Link to="/">
                  <img className="navigation__logo" src={`${logoImage}`} alt="VixAcademy Logo" />
                </Link>
              </div> */}
            </div>

            <div>
              <img className="navigation__logo" src={logoImage} alt="VixAcademy Logo" onClick={() => navigate("/")} />
            </div>
            <ul className="navigation__menu">
              <li> <NavLink className={menuItemClass} to="/admin/dashboard"> Dashboard </NavLink> </li>
              <li> <NavLink className={menuItemClass} to="/admin/users"> Manage Users </NavLink>  </li>
              <li> <NavLink className={menuItemClass} to="/admin/content"> Manage Content </NavLink> </li>
              <li>
                <button className={buttonClass} onClick={onSignOut}>
                  {currentUser?.name || "Sign Out"}
                </button>
              </li>
            </ul>   {mobileOpen && (
              <>
                <div className="mobile-overlay" onClick={() => setMobileOpen(false)}></div>
                <div className="mobile-menu">
                  <NavLink to="/admin/dashboard" onClick={() => setMobileOpen(false)}>Dashboard</NavLink>
                  <NavLink to="/admin/users" onClick={() => setMobileOpen(false)}>Manage Users</NavLink>
                  <NavLink to="/admin/content" onClick={() => setMobileOpen(false)}>Manage Content</NavLink>
                </div>
              </>
            )}
          </nav> 
       
          
        ) : // ManageUsers - users db ekrani / popup predeletion
        isUser ? (
          <nav className={`${navClass}`}>

            <div className="nav-mobile">
              <button className={`navigation__hamburger ${mobileOpen ? 'is-open' : ''}`} onClick={() => setMobileOpen(prev => !prev)}>
                {mobileOpen ? 'X': '☰' }
              </button>
              {/* <div className="logo-part">
                <Link to="/">
                  <img className="navigation__logo" src={`${logoImage}`} alt="VixAcademy Logo" />
                </Link>
              </div> */}
            </div>


            <div>
              <img className="navigation__logo" src={`${logoImage}`} alt="VixAcademy Logo" onClick={() => navigate("/")}   />
            </div>
            <ul className="navigation__menu">
              <li className="navigation__menu-list dropdown videos">
                <NavLink
                  className={`${menuItemClass}`}
                  to="/videos/1-1-1-what-is-forex"
                >
                  {t("videoCourses")}
                  <img className="dropdown-arrow" src={menuArrow} />
                </NavLink>
                {/*     <div className="nav-submenu">
                  <NavLink className="nav-sublink" to="/notes">Notes</NavLink>
                </div> */}
              </li>
              <li className="navigation__menu-list dropdown ebooks">
                <NavLink className={`${menuItemClass}`} to="/docs/">
                  {t("ebooks")} <img className="dropdown-arrow" src={menuArrow} />
                </NavLink>
              </li>
              <li className="navigation__menu-list">
                <NavLink className={`${menuItemClass}`} to="/notes">
                  {t("notes")}
                </NavLink>
              </li>
              <li className="navigation__menu-list">
                <NavLink className={`${menuItemClass}`} to="/utils">
                  {t("tools")}{" "}
                </NavLink>
              </li>
              <li className="navigation__menu-list">
                <NavLink className={`${menuItemClass}`} to="/utils/glossary">
                  {t("glossary").toUpperCase()}{" "}
                </NavLink>
              </li>
              
              <li className="navigation__menu-list dropdown">
                <NavLink className={`${menuItemClass}`} >
                  {t("courses")}{" "}
                </NavLink>
                  <div className="nav-submenu">
                    <NavLink className="nav-sublink" to="/courses">
                      {t("courses")}
                    </NavLink>
                    <NavLink className="nav-sublink" to="/packages">
                      {t("packages")}
                    </NavLink>
                    <NavLink className="nav-sublink" to="/aboutus">
                      {t("aboutUs")}
                    </NavLink>
                  </div>
              </li>
            </ul>
            <ul className="navigation__menu">
              <button className="langButton" onClick={onLanguage}>
                <img src={LangIcon} alt="Language" />
                <span className="lang-code">{language.toUpperCase()}</span>
              </button>
              {showLangMenu && (
                <ul className="language-dropdown" ref={langRef}>
                  {LANGUAGES.map((lang) => (
                    <li
                      key={lang.code}
                      className="language-dropmenu-item"
                      onClick={() => handleSelect(lang.code)}
                    >
                      {lang.label.toUpperCase()}
                    </li>
                  ))}
                </ul>
              )}

              <li className="navigation__menu-list">
                <Link to="/content">
                  <img src={Home} alt="Home" />
                </Link>
              </li>

              <li className="navigation__menu-list dropdown profile">
            {/*<button onClick={toggleSignout}>
                  <img src={Profile} />
                </button>{" "} */}
                {currentUser?.name.slice(0,1) || 'Sign Out'}
                <div className="nav-submenu userinfo">
                  <div className="userinfo-item">
                    <Link to="/content" className="userinfo-link">
                      <img src={ProfileLite} />
                      <span className="userinfo-name">{currentUser?.name}</span>
                    </Link>
                  </div>
                  <div className="userinfo-item">
                    <a onClick={onSignOut} className="userinfo-link">
                      <img src={SignOut} />
                      <span>{t("logout")}</span>
                    </a>
                  </div>

                  {/* <p><img src={Logout} onClick={onSignOut} style={{width:"15px", marginLeft:"5px", padding:"0 4px"}}/> Log Out</p> */}
                </div>
              </li>

              {/*             <li>
                <button className="navigation__menu-item-mobile-button" onClick={onMobileMenu} />
              </li> */}

            </ul>          
            {mobileOpen && (
              <>
                <div className="mobile-overlay" onClick={() => setMobileOpen(false)}></div>
                <div className="mobile-menu">
                  <NavLink to="/content" onClick={() => setMobileOpen(false)}>{t('home')}</NavLink>
                  <NavLink to="/videos/1-1-1-what-is-forex" onClick={() => setMobileOpen(false)}>{t('videoCourses')}</NavLink>
                  <NavLink to="/docs" onClick={() => setMobileOpen(false)}>{t('ebooks')}</NavLink>
                  <NavLink to="/notes" onClick={() => setMobileOpen(false)}>{t('notes')}</NavLink>
                  <NavLink to="/utils" onClick={() => setMobileOpen(false)}>{t('tools')}</NavLink>
                  <NavLink to="/glossary" onClick={() => setMobileOpen(false)}>{t('glossary')}</NavLink>
                  <NavLink to="/courses" onClick={() => setMobileOpen(false)}>{t('courses')}</NavLink>
                  <NavLink to="/packages" onClick={() => setMobileOpen(false)}>{t('packages')}</NavLink>
                  <NavLink to="/aboutus" onClick={()=> setMobileOpen(false)}>{t('aboutus')}</NavLink>
                  <NavLink  onClick={onSignOut}>{t('logout')}</NavLink>
                </div>
              </>
            )}
          </nav>

        ) : (
          
          <nav className="navigation">

            <div className="nav-mobile">
              <button className={`navigation__hamburger ${mobileOpen ? 'is-open' : ''}`} onClick={() => setMobileOpen(prev => !prev)}>
                {mobileOpen ? 'X': '☰' }
              </button>
{/*               <div className="logo-part">
                <Link to="/">
                  <img className="navigation__logo" src={`${logoImage}`} alt="VixAcademy Logo" />
                </Link>
              </div> */}
            </div>

            <div className="">
              <Link to="/">
                <img
                  className="navigation__logo"
                  src={`${logoImage}`}
                  alt="VixAcademy Logo"
                />
              </Link>
            </div>
            <ul className="navigation__menu">
              <li className="navigation__menu-list">
                <NavLink className={`${menuItemClass}`} to="/courses">
                  {t("courses")}
                </NavLink>
              </li>
              <li className="navigation__menu-list">
                <NavLink className={`${menuItemClass}`} to="/aboutus">
                  {t("aboutUs")}
                </NavLink>
              </li>
            </ul>
            <ul className="navigation__menu icons">
              <button className="langButton" onClick={onLanguage}>
                <img src={LangIcon} />
                <span className="lang-code">{language.toUpperCase()}</span>
              </button>
              {showLangMenu && (
                <ul className="language-dropdown" ref={langRef}>
                  {LANGUAGES.map((lang) => (
                    <li
                      key={lang.code}
                      className="language-dropmenu-item"
                      onClick={() => handleSelect(lang.code)}
                    >
                      {lang.label.toUpperCase()}
                    </li>
                  ))}
                </ul>
              )}
              <li className="navigation__menu-list">
                <Link to="/">
                  <img src={Home} alt="Home" />
                </Link>
              </li>
              <li className="navigation__menu-list">
                <button
                  onClick={() => {   
                    console.log("clicked");
                    onDesktopClick();
                  }}>
                  {t('signIn')}{/*  <img src={SignIn} /> */}
                </button>

                {/* <button className="navigation__menu-item-mobile-button" onClick={onMobileClick}>
                        <img src={SignIn}/>
                    </button> */}
              </li>


            </ul>          
            {mobileOpen && (
              <>
                <div className="mobile-overlay" onClick={() => setMobileOpen(false)}></div>
                <div className="mobile-menu">
                  <NavLink to="/" onClick={() => setMobileOpen(false)}>{t('home')}</NavLink>
                  <NavLink to="/aboutus" onClick={() => setMobileOpen(false)}>{t('aboutus')}</NavLink>
                  <NavLink to="/courses" onClick={() => setMobileOpen(false)}>{t('courses')}</NavLink>
                  <button onClick={() => {
                    setMobileOpen(false);
                    onMobileClick();
                  }}>
                      {t('signIn')}
                  </button>
                </div>
              </>
            )}
          </nav>

          
        )
      }
    </>
  );
}

export default Navigation;
